import React from "react";

const SuccessIcon = props => {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    className: ["akui-mobile-icon", props.className].filter(Boolean).join(" "),
    style: Object.assign({
      verticalAlign: "-0.125em"
    }, props.style)
  }), React.createElement("title", null, "BE4E7D81-3958-4F2E-9956-E6071199885F@2x"), React.createElement("svg", {
    viewBox: "0 0 72 72"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z",
    fill: "#FFF"
  }), React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: "2",
    d: "M19 34.54l11.545 11.923L52.815 24"
  }))));
};

export default SuccessIcon;